<footer class="text-center justify-content-center text-lg-start">
  <div class="text-center p-3" >
    © 2021 Copyright: You Dont know EGYPT
    <div class="ilogo text-center">
      <i class="fa fa-facebook" aria-hidden="true"></i>
      <i class="fa fa-google" aria-hidden="true"></i>
      <i class="fa fa-twitter" aria-hidden="true"></i>
    </div>
  </div>
</footer>
